import React from 'react';

import { useFiltersFieldsManagerContext } from '../FilterFieldsManager';
import {
  useFiltersStateManager,
  isEqualFilterValues,
} from '../FiltersStateManager';
import FiltersSettings, { useFiltersSettings } from './FiltersSettings';
import { FILTERS_MODE_PRIMARY } from './constants';

export const PrimaryFiltersProvider = ({ children, defaultPrimaryFilters }) => {
  const { isFilterFavorite, ...ctx } = useFiltersSettings();
  const { getFilterFields } = useFiltersFieldsManagerContext();
  const { getFilterValue, getFilterEmptyValue } = useFiltersStateManager();

  const isFilterPrimaryDefault = ({ name }) =>
    defaultPrimaryFilters ? defaultPrimaryFilters.includes(name) : true;

  const isFilterVisible = ({ name }) => {
    return (
      isFilterPrimaryDefault({ name }) ||
      isFilterFavorite({ name }) ||
      !getFilterFields({ name }).every(({ path, basePath }) => {
        const emptyValue = getFilterEmptyValue(path);
        return isEqualFilterValues(
          getFilterValue(path),
          emptyValue != null ? emptyValue : getFilterEmptyValue(basePath)
        );
      })
    );
  };

  return (
    <FiltersSettings.Provider
      value={{
        ...ctx,
        mode: FILTERS_MODE_PRIMARY,
        isFilterPrimaryDefault,
        isFilterVisible,
        isFilterFavorite,
      }}
    >
      {children}
    </FiltersSettings.Provider>
  );
};

export default PrimaryFiltersProvider;
